import React, { useEffect, useState, Fragment } from "react";
import FabComponent from "../chatBoxFab";
import PrescriptionFab from "../prescriptionFab";
// import IconButton from "@material-ui/core/IconButton";
// import MicIcon from "@material-ui/icons/Mic";
import Camera, { FACING_MODES, IMAGE_TYPES } from "react-html5-camera-photo";
import * as HTTPServices from "../../../api/HTTPServices";
import "react-html5-camera-photo/build/css/index.css";
import appConfig from "../../../config/appConfig";
import ImagePreview from "../chatBoxFab/ImagePreview";
import Modal from "@material-ui/core/Modal";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
// import Button from "@material-ui/core/Button";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import CircularProgress from "@material-ui/core/CircularProgress";

import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import TextareaAutosize from '@mui/material/TextareaAutosize';


// import "../chatBox/reset.css";
import "./ChatBox.css";

export default function ChatBox({
  handleTextChange,
  handleSend,
  text,
  handleOpenFileUploadDialog,
  handleOpenFileUploadDialogDR,
  handleOpenVoiceRecorderDialog,
  handleOpenVideoeRecorderDialog,
  handleOpenCompressedImageDialog,
  medicalDocuments,
  medicalInstructions,
  showReplyDiv,
  cancelRepleing,
  AudienceID,
  VisitToken,
  addMessageToList,
  attachType,
  setAttachTypeprescription,
  setAttachTypeDefault,
  selectedToReply,
}) {
  const [userLogin, setUserLogin] = useState(null);
  const [camera, setCamera] = useState(false);
  const [dataUri, setDataUri] = useState("");
  const [confirm, setConfirm] = useState(false);
  const [facingMode, setFacingMode] = useState("FACING_MODES.ENVIRONMENT");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const RequestService = HTTPServices.getMethod("get_start", "", "true");
    RequestService.then(function (response) {
      if (response) {
        setUserLogin(response.user_login);
        document.cookie = `token=${response.user_login.api_token}; domain=.${appConfig.cookie.domain}; path=/;`;
      }
    });
  }, []);

  useEffect(() => {
    return () => {
      if (!camera) {
        setDataUri("");
      }
    };
  }, [camera]);

  function handleTakePhotoAnimationDone(dataUri) {
    setDataUri(dataUri);
    setTimeout(() => {
      setConfirm(true);
    }, 2000);
  }

  function submitShot() {
    setLoading(true);
    let shotTaken = [];
    function dataURLtoFile(dataurl, filename) {
      var arr = dataurl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);

      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }

      return new File([u8arr], filename, { type: mime });
    }
    var convertedFile = dataURLtoFile(dataUri, `${Math.random(10)}.jpg`);

    let formData = new FormData();
    formData.append("message", "");
    formData.append("audience", AudienceID);
    formData.append("room_token", VisitToken);
    formData.append("length", 1);

    if (attachType == "prescription") {
      formData.append("type", "prescriptionPhoto");
    } else {
      formData.append("type", "dossierPhoto");
    }
    formData.append(`file0`, convertedFile);

    const RequestService = HTTPServices.postMethod("send2", formData, "true");
    RequestService.then(function (response) {
      
      if (response) {
        setAttachTypeDefault();
        // setDataUri("");
        setConfirm(false);
        setCamera(false);
        addMessageToList(response.data[0]);
        setLoading(false);
      }
      setLoading(false);
    }).catch(function (error) { setLoading(false); });
  }

  function getFileExtension(filename) {
    if (filename != null) {
      return filename.split(".").pop();
    } else {
      return;
    }
  }

  const isFullscreen = false;
  console.log(selectedToReply, 'selectedToReply.message');

  // const replyView = (e) => {
  //   switch (e) {
  //     case 'dossierFile': return (
  //       <img style={{ height: '100%', resize: 'contain' }} src={selectedToReply.file} />
  //     )
  //     case 'dossierFile': return (
  //       <img style={{ height: '100%', resize: 'contain' }} src={selectedToReply.file} />
  //     )

  //       break;

  //     default:
  //       break;
  //   }
  // }
  return (
    <>
      {showReplyDiv ? (
        // <div style={styles.wrap}>
        //   <div style={styles.box}>
        //     پاسخ به :{selectedToReply}
        //     <div style={styles.replyText}>{text ? text : null}</div>
        //   </div>
        // </div>
        <div className='chat_reply_container'>
          <div style={{ fontSize: 11 }}>پاسخ به:</div>
          <div className='reply_container'>
            <div className='reply'>

              {selectedToReply.file &&
                <div className='reply_img'>
                  <img style={{ height: '100%', resize: 'contain' }} src={selectedToReply.file} />
                  {/* {replyView(selectedToReply.type)} */}
                </div>
              }
              <div className='reply_msg'>{selectedToReply.message}</div>
            </div>
            <div className='cancel_btn_container' onClick={cancelRepleing}><CancelOutlinedIcon /></div>
          </div>
        </div>
      ) : null}

      <div style={{ width: '100%', display: 'flex', alignItems: 'flex-end' }}>
        {userLogin && userLogin.approve == "doctor" ? (
          <ul style={styles.ul}>
            <li className="step6-dr" style={styles.li}>
              <PrescriptionFab
                shot={() => setCamera(true)}
                handleOpenFileUploadDialog={handleOpenFileUploadDialogDR}
                handleOpenVoiceRecorderDialog={handleOpenVoiceRecorderDialog}
                handleOpenVideoeRecorderDialog={handleOpenVideoeRecorderDialog}
                setAttachType={() => {
                  setAttachTypeprescription();
                }}
              />
            </li>
            <li className="step7-dr" style={styles.li}>
              <FabComponent
                userLogin={userLogin}
                shot={() => setCamera(true)}
                // handleOpenCompressedImageDialog={handleOpenCompressedImageDialog}
                // medicalInstructions={medicalInstructions}
                // medicalDocuments={medicalDocuments}
                handleOpenFileUploadDialog={handleOpenFileUploadDialog}
                handleOpenVoiceRecorderDialog={handleOpenVoiceRecorderDialog}
                handleOpenVideoeRecorderDialog={handleOpenVideoeRecorderDialog}
                setAttachTypeDefault={() => { setAttachTypeDefault(); }}
              />
            </li>
          </ul>
        ) : (
          <>
            <div className="step5-user">
              <FabComponent
                userLogin={userLogin}
                shot={() => setCamera(true)}
                // handleOpenCompressedImageDialog={
                //   handleOpenCompressedImageDialog
                // }
                medicalInstructions={medicalInstructions}
                medicalDocuments={medicalDocuments}
                handleOpenFileUploadDialog={handleOpenFileUploadDialog}
                handleOpenVoiceRecorderDialog={handleOpenVoiceRecorderDialog}
                handleOpenVideoeRecorderDialog={handleOpenVideoeRecorderDialog}
                AudienceID={AudienceID}
                VisitToken={VisitToken}
                setAttachTypeDefault={() => {
                  setAttachTypeDefault();
                }}
              />
            </div>
          </>
        )}

        {/* <div className="text_type step9-user">
          <input
            type="text"
            value={text}
            placeholder="پیام خود را تایپ کنید..."
            className="form-control chat_type"
            onChange={handleTextChange}
            onKeyDown={handleTextChange}
          />
        </div>

        <div className="chat_bottom">
          <button
            id="Submit"
            className="btn btn-send-message"
            onClick={handleSend}
          >ارسال</button>
        </div> */}

        <div className='message_input_container'>
          <TextareaAutosize
            aria-label="empty textarea"
            maxRows={2}
            type="text"
            value={text}
            placeholder="پیام خود را تایپ کنید..."
            onChange={handleTextChange}
            // onKeyDown={handleTextChange}
            className='message_input'
          />
          <button onClick={handleSend} className='message_send_btn_container'>
            ارسال
          </button>
        </div>

      </div>

      {confirm && (
        <div>
          <Dialog
            open={true}
            // onClose={() => {
            //   setConfirm(false);
            // }}
            aria-labelledby="form-dialog-title"
          >
            <DialogContent>
              <DialogContentText className="dialog_text">
                مناسب است؟
              </DialogContentText>
            </DialogContent>

            {loading == false ? (
              <DialogActions>
                <button className="button"
                  onClick={() => {
                    setDataUri("");
                    setConfirm(false);
                  }}>دوباره</button>
                <button onClick={submitShot} color="primary" className="button">ارسال</button>
                <button
                  onClick={() => {
                    setDataUri("");
                    setConfirm(false);
                    setCamera(false);
                    setAttachTypeDefault();
                  }}
                  className="button error"
                >
                  انصراف
                </button>
              </DialogActions>
            ) : (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  textAlign: "center",
                  alignItems: "center",
                }}
              >
                <CircularProgress />
              </div>
            )}
          </Dialog>
        </div>
      )}


      <Modal
        open={camera}
        onClose={() => setCamera(false)}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
      >
        {dataUri ? (
          <ImagePreview dataUri={dataUri} isFullscreen={isFullscreen} />
        ) : (
          <Camera
            onTakePhotoAnimationDone={handleTakePhotoAnimationDone}
            onCameraError={() => {
              alert("دستگاه دارای دوربین نمی باشد یا با اشکال مواجه است");
              setDataUri("");
              setConfirm(false);
              setCamera(false);
              setAttachTypeDefault();
            }}
            isFullscreen={isFullscreen}
            idealFacingMode={FACING_MODES.ENVIRONMENT}
            isImageMirror={false}
          />
        )}
      </Modal>
    </>
  );
}

const styles = {
  wrap: {
    // margin : "15px",
    paddingButton: 0,
    position: "absolute",
    zIndex: 1,
    width: "70%",
    bottom: "2px",
    height: "auto",
    right: 5,
    border: '1px solid red'
  },
  box: {
    height: "auto",
    borderRadius: "13px 2px 13px 13px",
    backgroundColor: "rgb(255 226 164)",
    padding: 10,
    color: "#0007",
    boxShadow: "0 3px 7px -3px rgb(175 149 93)",
    fontSize: ".8em",
  },
  replyText: {
    paddingRight: 50,
    marginTop: 10,
    backgroundColor: "lightgreen",
    display: "none",
  },
  ul: {
    listStyleType: "none",
    margin: 0,
    padding: 0,
  },
  li: {
    float: "right",
    // marginLeft: 3,
    textAlign: "center",
    fontSize: 12,
    // color: "white",
  },
};
